module.exports = __webpack_public_path__ + "static/img/title_logo.d0c2c46.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/test/title_logo.png
// module id = eTt5
// module chunks = 1